module.exports = Promise.all([__parcel__import__("2svxS"), __parcel__import__("iMjc0")]).then(() => parcelRequire('4MH6n'));